<button (click)="openCreate()" class="btn btn-primary-outline add-button">Add</button>
<h4>Store Trading Times</h4>
<table class="table table-striped">
  <thead>
  <tr>
    <th>Working time</th>
    <th>Start date</th>
    <th></th>
  </tr>
  </thead>
  <tbody>
    @for (defaultWorkingTime of defaultWorkingTimes(); track defaultWorkingTime) {
      <tr>
        <td>
          <div class="working-times-column col-lg-6 col-md-12">
            @for (dayOfWeek of daysOfWeekValues | slice:0:4; track dayOfWeek) {
              <div>
                <div class="day-of-week">{{ dayOfWeek | dayOfWeekParse }}</div>
                <div class="day-of-week-working-time">
                  {{ defaultWorkingTime.weeklyTimes.get(dayOfWeek).openingTime | timeParse | dateFormat: 'HH:mm' }} -
                  {{ defaultWorkingTime.weeklyTimes.get(dayOfWeek).closingTime | timeParse | dateFormat: 'HH:mm' }}
                </div>
              </div>
            }
          </div>
          <div class="working-times-column col-lg-6 col-md-12">
            @for (dayOfWeek of daysOfWeekValues | slice:4:7; track dayOfWeek) {
              <div>
                <div class="day-of-week">{{ dayOfWeek | dayOfWeekParse }}</div>
                <div class="day-of-week-working-time">
                  {{ defaultWorkingTime.weeklyTimes.get(dayOfWeek).openingTime | timeParse | dateFormat: 'HH:mm' }} -
                  {{ defaultWorkingTime.weeklyTimes.get(dayOfWeek).closingTime | timeParse | dateFormat: 'HH:mm' }}
                </div>
              </div>
            }
          </div>
        </td>
        <td>
          <div class="date-column">{{ defaultWorkingTime.startDate }}</div>
        </td>
        <td>
          @if (canEditAtDate(defaultWorkingTime.startDate)) {
            <i
                    (click)="openUpdate(defaultWorkingTime)"
                    class="fa fa-xs fa-pen pointer me-1">
            </i>
          }
          @if (canEditAtDate(defaultWorkingTime.startDate)) {
            <i
                    (click)="openDelete(defaultWorkingTime.startDate)"
                    class="fa fa-xs fa-trash pointer">
            </i>
          }
        </td>
      </tr>
    }
  </tbody>
</table>